<template>
  <h1 v-if="type === 'h1'"><slot></slot></h1>
  <h3 v-else-if="type === 'h3'"><slot></slot></h3>
  <h5 v-else-if="type === 'h5'"><slot></slot></h5>
</template>
<script>
export default {
  name: "SettingsTitle",
  props: {
    type: {
      type: String,
      validator: (type) => ["h1", "h3", "h5"].includes(type),
    }
  },
  computed: {
    getClass() {
      return "settings-"+this.type;
    }
  }
}
</script>
<style scoped>
h1 {
  font-size: 44px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #222;
}
h3 {
  font-size: 24px;
  font-weight: 600;
  margin-top: 6px;
  margin-bottom: 6px;
  color: #222;
  display: block;
}
h5 {
  font-size: 16px;
  font-weight: 700;
  /* margin-top: 6px;
  margin-bottom: 6px; */
  color: #222;
}
</style>